var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',[_vm._l((3),function(i){return _c('v-col',{key:i,attrs:{"cols":"12","sm":"3"}},[_c('v-skeleton-loader',{attrs:{"type":"card"}})],1)}),_c('v-col',{attrs:{"cols":"12"}},[_c('v-skeleton-loader',{attrs:{"type":"article"}})],1)],2)}
var staticRenderFns = []

export { render, staticRenderFns }